import { colors } from '@pff-consumer/core-ui'
import { NativeUiTheme } from '../../../styles/theme'

export const getColorVariants = (theme: NativeUiTheme, variant: string, isLoading?: boolean) => {
  switch (variant) {
    case 'secondary': {
      return {
        bg: !isLoading ? theme.colors.secondaryButtonBackground : theme.colors.secondaryButtonBackgroundActive,
        border: !isLoading ? theme.colors.secondaryButtonBorder : theme.colors.secondaryButtonBorderActive,
        text: !isLoading ? theme.colors.secondaryButtonColor : theme.colors.secondaryButtonColorActive,
        bgHover: theme.colors.secondaryButtonBackgroundActive,
        borderHover: theme.colors.secondaryButtonBorderActive,
        textHover: theme.colors.secondaryButtonColorActive,
      }
    }
    case 'tertiary': {
      return {
        bg: !isLoading ? theme.colors.tertiaryButtonBackground : theme.colors.tertiaryButtonBackgroundActive,
        border: !isLoading ? theme.colors.tertiaryButtonBorder : theme.colors.tertiaryButtonBorderActive,
        text: !isLoading ? theme.colors.tertiaryButtonColor : theme.colors.tertiaryButtonColorActive,
        bgHover: theme.colors.tertiaryButtonBackgroundActive,
        borderHover: theme.colors.tertiaryButtonBorderActive,
        textHover: theme.colors.tertiaryButtonColorActive,
      }
    }
    case 'abandon': {
      return {
        bg: !isLoading ? colors.abandonButtonBackground : theme.colors.abandonButtonBackgroundActive,
        border: !isLoading ? colors.abandonButtonBorder : theme.colors.abandonButtonBorderActive,
        text: !isLoading ? theme.colors.abandonButtonColor : theme.colors.abandonButtonColorActive,
        bgHover: theme.colors.abandonButtonBackgroundActive,
        borderHover: theme.colors.abandonButtonBorderActive,
        textHover: theme.colors.abandonButtonColorActive,
      }
    }
    case 'quaternary': {
      return {
        bg: !isLoading ? theme.colors.quaternaryButtonBackgroundActive : theme.colors.quaternaryButtonBackground,
        border: theme.colors.quaternaryButtonBorder,
        text: !isLoading ? theme.colors.quaternaryButtonColorActive : theme.colors.quaternaryButtonColor,
        bgHover: theme.colors.quaternaryButtonBackgroundHover,
        borderHover: theme.colors.quaternaryButtonBorder,
        textHover: theme.colors.quaternaryButtonColorActive,
      }
    }
    case 'primary':
    default: {
      return {
        bg: !isLoading ? theme.colors.primaryButtonBackground : theme.colors.primaryButtonBackgroundActive,
        border: !isLoading ? theme.colors.primaryButtonBorder : theme.colors.primaryButtonBorderActive,
        text: !isLoading ? theme.colors.primaryButtonColor : theme.colors.primaryButtonColorActive,
        bgHover: theme.colors.primaryButtonBackgroundActive,
        borderHover: theme.colors.primaryButtonBorderActive,
        textHover: theme.colors.primaryButtonColorActive,
      }
    }
  }
}
